<h5 mat-dialog-title>Note Details</h5>
<p style="text-align: justify;" [innerHTML]="data.name"></p>
<div mat-dialog-actions align="middle">
  <button class="btn" style="background-color: var(--mk3red); color:white ;" (click)="onNoClick()">Close</button>
</div>
